<template>
  <div id="query">

<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">证书查询 </li>
</ul>
</div>
</div>

<div style="margin:0 auto" class="widu">



<div class="col-md-6 col-md-offset-2">
<div class="panel panel-default" style="margin-top:40px">
  <div class="panel-heading">证书查询</div>

    <div class="panel-body">
    <form action="" class="myform form-horizontal" method="post" target="_blank">
  
    <div class="form-group">
    <label for="inputEmail3" class="col-sm-2 control-label">证书号</label>
    <div class="col-sm-8">
      <input type="text" class="form-control" name="CertNumber" id="inputEmail3" placeholder="证书号" v-model="CertNumber">
    </div>
  </div>
 

  <div class="form-group">
    <label  class="col-sm-2 control-label" >证书类型</label>
    <div class="col-sm-6">
<select class="form-control" name="CertType" v-model="CertType">
  <option value="GIA">GIA</option>
  <option value="IGI">IGI</option>
</select>


</div>
  </div>

 
  <div class="form-group">
    <div class="col-sm-offset-2 col-sm-8">
      <button type="button" class="btn btn-default" v-on:click="query()">查询</button>
    </div>
  </div>


</form>
</div>


</div>
</div>





</div>


<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                              <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>


  </div>


</template>

<script>

export default {
  name: 'Query',
  data(){
  return {
  title:"证书查询",
  CertNumber: '' ,
  CertType: 'GIA' ,
  diamonds:[]
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
      query: function () {
         if(!this.CertType){
            alert('证书类型不能为空');
            return false;
         }
         if(!this.CertNumber.trim()){
            alert('证书号不能为空');
            return false;
         }
         
         if(this.CertType=='GIA'){
          var url='https://www.gia.edu/report-check?reportno=' + this.CertNumber.trim();
         } else if(this.CertType=='IGI'){
          var url='http://global.igiworldwide.com/ch/viewpdf.php?m=false&r=' + this.CertNumber.trim();
         }
         console.log(url);
         window.open(url);
        // window.location.href = url;
     }
  },
  components:{
  },
  created(){
    
  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}

</style>


// WEBPACK FOOTER //
// src/components/Query.vue